import "../css/Popups.css";

function Skills({onClose}){
    return(
        <div className="shade">
            <section id="popup">
                <div className="top">
                    <h1>Skills</h1>
                    <button onClick={onClose} className="closeBtn">X</button>
                </div>

                <div className="mid">
                    <div>
                        <h2>Front-end Skills</h2>
                        <ul>
                            <li>HTML, CSS</li>
                            <li>JavaScript</li>
                            <li>ReactJS</li>
                        </ul>
                        <h2>Backend-end Skills</h2>
                        <ul>
                            <li>PHP</li>
                            <li>MySQL</li>
                        </ul>
                    </div>
                </div>

                <div className="bottom">
                    <img src={require("../images/about-bottom.png")} alt="" width="100%" height="50px" />
                </div>
            </section>
        </div>

    )
}
 export default Skills;